
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep3 {
  willSubjectsReceiveAnything: string;
  receiveDetail: string;
}

export default defineComponent({
  name: "step-3",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step3 = ref<IStep3>({
      willSubjectsReceiveAnything: "0",
      receiveDetail: "",
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    watchEffect(() => {
      const data = store.getters.currentRecruitment;
      if (data === null || data.data === undefined) return;
      step3.value.willSubjectsReceiveAnything = data.data
        .willSubjectsReceiveAnything
        ? "1"
        : "0";
      step3.value.receiveDetail = data.data.receiveDetail || "";
    });

    return {
      step3,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
